import type { LocalizedText } from "@/domain/localized";
import { Button } from "../Button";
import { useLocale } from "../../i18n/LocaleProvider";
import styles from "./questions.module.css";

interface Props {
  value: boolean | undefined;
  labels?: { yes: LocalizedText; no: LocalizedText };
  onSubmit: (value: boolean) => void;
}

export function YesNoInput({ value, labels, onSubmit }: Props) {
  const { t, pick } = useLocale();
  const yes = labels ? pick(labels.yes) : t.common.yes;
  const no = labels ? pick(labels.no) : t.common.no;
  return (
    <div className={styles.row}>
      <Button block selected={value === true} onClick={() => onSubmit(true)}>{yes}</Button>
      <Button block selected={value === false} onClick={() => onSubmit(false)}>{no}</Button>
    </div>
  );
}
